import { aboutData } from "../data/mock";
import { Quote, MapPin, Users, Briefcase, Instagram, Youtube, ArrowUpRight } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" className="relative py-28" style={{ background: "#1a1c1b" }}>
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
      <div className="max-w-[87.5rem] mx-auto px-10">
        <span className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          Who Am I
        </span>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Text Content */}
          <div>
            {/* Name prominently */}
            <h2 className="text-[#d9fb06] font-black text-3xl md:text-4xl uppercase tracking-tight mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {aboutData.name}
            </h2>
            <p className="text-[#888680] text-sm font-medium mb-8" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {aboutData.handle} · Chartered Accountant (ICAI)
            </p>

            <h3 className="font-bold text-xl leading-snug mb-8" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              <span className="text-[#dfddd6]">"I've been on </span>
              <span className="text-[#d9fb06]">both sides</span>
              <span className="text-[#dfddd6]"> of this."</span>
            </h3>

            <Quote size={20} className="text-[#3f4816]/50 mb-4" />

            <p className="text-[#888680] text-sm leading-relaxed mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              Started in corporate India — fund accounting, investment analysis, financial reporting. <span className="text-[#dfddd6] font-medium">Did my CA.</span> Understood the Indian system inside out.
            </p>
            <p className="text-[#dfddd6] text-sm leading-relaxed font-medium mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              Then I moved to Dubai and saw what nobody was solving.
            </p>
            <p className="text-[#888680] text-sm leading-relaxed mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              NRIs across <span className="text-[#dfddd6]">US, UK, Canada, Singapore, Australia</span> were filing taxes with CAs who had never heard of DTAA or FEMA. Nobody sat at the intersection.
            </p>
            <p className="text-[#888680] text-sm leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              So I built <span className="text-[#d9fb06] font-semibold">Finpire Global</span> — right here in Dubai — to be that one firm.
            </p>

            {/* Specific result callout */}
            <div className="mt-6 bg-[#d9fb06]/5 border border-[#d9fb06]/15 px-5 py-4 rounded-sm">
              <p className="text-[#dfddd6] text-sm font-semibold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {aboutData.specificResult}
              </p>
            </div>

            {/* Quick stats */}
            <div className="mt-8 flex flex-wrap gap-5">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-md bg-[#3f4816]/20 border border-[#3f4816]/30 flex items-center justify-center">
                  <Users size={14} className="text-[#d9fb06]" />
                </div>
                <span className="text-[#dfddd6] text-sm font-bold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>1,000+ clients</span>
              </div>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-md bg-[#3f4816]/20 border border-[#3f4816]/30 flex items-center justify-center">
                  <MapPin size={14} className="text-[#d9fb06]" />
                </div>
                <span className="text-[#dfddd6] text-sm font-bold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>40+ countries</span>
              </div>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-md bg-[#3f4816]/20 border border-[#3f4816]/30 flex items-center justify-center">
                  <Briefcase size={14} className="text-[#d9fb06]" />
                </div>
                <span className="text-[#dfddd6] text-sm font-bold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>One team, both sides</span>
              </div>
            </div>

            {/* Social links */}
            <div className="mt-8 flex items-center gap-3">
              <a href={aboutData.social.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#888680] text-xs font-medium border border-[#3f4816]/30 px-4 py-2 rounded-full transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]">
                <Instagram size={14} /> Instagram <ArrowUpRight size={10} />
              </a>
              <a href={aboutData.social.youtube} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#888680] text-xs font-medium border border-[#3f4816]/30 px-4 py-2 rounded-full transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]">
                <Youtube size={14} /> YouTube <ArrowUpRight size={10} />
              </a>
            </div>
          </div>

          {/* Photo */}
          <div className="flex items-center justify-center">
            <div className="relative">
              <div className="absolute -inset-3 rounded-full border border-[#3f4816]/25" />
              <div className="w-72 h-72 rounded-full overflow-hidden border-2 border-[#3f4816]/40">
                <img src={aboutData.image} alt="CA Rahul Taneja" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
